import {Button, Dropdown, Form, Input} from "semantic-ui-react";
import {IItem} from "../../interfaces/Item";
import {useAppDispatch} from "../../app/hooks";
import {ChangeObjectResize, ChangePicture, ChangeValueNoHistory} from "../MainActions";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {VARIABLE_PICTURE} from "../../utils/ItemTypes";
import localforage from "localforage";
import {ITag} from "../../interfaces/Tag";
import { round } from "../../utils/constants";
import { useTranslation } from "react-i18next";

interface Props {
  style: any;
  selectedItem: IItem;
  pxInMM: number;
  onChangeWithStyle: (propName: string, propValue: any, propNameStyle: string, propValueStyle: any) => void;
  onChange: (propName: string, propValue: any) => void;
  handleAddNewRecord?: () => void;
  role: string;
}

export const PictureForm = ({style, selectedItem, pxInMM, onChangeWithStyle, onChange, handleAddNewRecord, role}: Props) => {
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const {defaultPath} = useSelector((state: RootState) => state.labelEdit.present.labelParams);
  const imgTags = useSelector((state: RootState) => state.refData.imgTags);
  const imgTagDD = imgTags?.map((item: ITag) => {
    return {
      key: item.id,
      text: item.name,
      value: item.id,
    };
  });
  const onPathChange = async (event: any) => {
    const file: File | undefined = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      image.src = e.target!.result as string;

      //Validate the File Height and Width.
      image.onload = function () {
        var height = image.height;
        var width = image.width;
        dispatch(ChangeObjectResize(selectedItem, width / pxInMM, "height", height / pxInMM));
        dispatch(ChangeValueNoHistory(selectedItem, "base64", image.src));
      };
    };

    const previousUrl = selectedItem.value;
    const newUrl = URL.createObjectURL(file);
    dispatch(ChangePicture(selectedItem, newUrl, defaultPath + file.name));
    await localforage.setItem(selectedItem.itemid.toString(), file);

    if (typeof previousUrl === "string" && previousUrl.startsWith("blob:") && previousUrl !== newUrl) {
      try {
        URL.revokeObjectURL(previousUrl);
      } catch {
        // ignore
      }
    }
    event.target.value = "";
  };
  return (
    <Form style={style.form}>
      {selectedItem.type === VARIABLE_PICTURE && (
        <Form.Field>
          <label style={{textAlign: "left"}}>{t("picture_name")}:</label>
          <div style={{display: "flex", alignItems: "start", width: "100%"}}>
            <Dropdown
              size="small"
              options={imgTagDD}
              value={selectedItem.name}
              fluid
              selection={true}
              search={(options, query) => 
                options.filter((option) => 
                  option.text?.toString().toLowerCase().includes(query.toLowerCase()) || 
                  option.value?.toString().toLowerCase().includes(query.toLowerCase())
                )
              }
              onChange={(e, data) => {
                onChange("name", data.value);
              }}
            />
            {(role === "admin" || role === "super_admin") && <Button onClick={handleAddNewRecord} className="icon" icon="plus" basic color="blue" style={{marginLeft: 4}} />}
          </div>
        </Form.Field>
      )}
      <Form.Field inline style={style.field}>
        <label>{t("x_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.xInMM)}
          onChange={(e) => {
            onChangeWithStyle("xInMM", Number(e.target.value), "left", `${Number(e.target.value) * pxInMM}px`);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("y_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.yInMM)}
          onChange={(e) => {
            onChangeWithStyle("yInMM", Number(e.target.value), "top", `${Number(e.target.value) * pxInMM}px`);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("width2")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.width)}
          onChange={(e) => {
            onChange("width", Number(e.target.value));
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("height")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.height)}
          onChange={(e) => {
            onChange("height", Number(e.target.value));
          }}
        />
      </Form.Field>

      <Form.Field inline style={style.field}>
        <label>{t("keep_ratio")}:</label>
        <Form.Checkbox
          checked={selectedItem.keepRatio ? true : false}
          onChange={(e, data) => {
            onChange("keepRatio", data.checked);
          }}
        />
      </Form.Field>

      <Form.Field>
        <label style={{textAlign: "left"}}>{t("picture_link")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          value={selectedItem.path}
          onChange={(e) => {
            onChange("path", e.target.value);
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("file")}:</label>
        <Input fluid size="small" type="file" style={{width: "80%", marginLeft: "auto"}} accept="image/*" onChange={onPathChange} />
      </Form.Field>
      <Form.Field inline style={style.field}>
        {/* <label>{t("bring_to_back")}:</label>
        <Form.Checkbox
          checked={selectedItem.bringBack === 1 ? true : false}
          onChange={(e, data) => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        /> */}
        <Button
          compact fluid basic
          onClick={() => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        >
          {t("bring_to_back")}
        </Button>
      </Form.Field>
    </Form>
  );
};
